const DB_NAME = 'logistics_blobs';
const STORE_NAME = 'blobs';
const DB_VERSION = 1;

let dbPromise: Promise<IDBDatabase> | null = null;

const openDb = (): Promise<IDBDatabase> => {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return dbPromise;
};

const run = <T>(mode: IDBTransactionMode, fn: (store: IDBObjectStore) => IDBRequest<T>): Promise<T> =>
  openDb().then(
    (db) =>
      new Promise<T>((resolve, reject) => {
        const tx = db.transaction(STORE_NAME, mode);
        const store = tx.objectStore(STORE_NAME);
        const req = fn(store);
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
      })
  );

export const putBlob = (key: string, dataURL: string): Promise<void> =>
  run('readwrite', (store) => store.put(dataURL, key) as IDBRequest<IDBValidKey>).then(() => undefined);

export const getBlob = (key: string): Promise<string | null> =>
  run<string | undefined>('readonly', (store) => store.get(key)).then((v) => v ?? null);

export const deleteBlob = (key: string): Promise<void> =>
  run('readwrite', (store) => store.delete(key) as IDBRequest<undefined>).then(() => undefined);

export const deleteBlobs = async (keys: string[]): Promise<void> => {
  if (keys.length === 0) return;
  const db = await openDb();
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    keys.forEach((k) => store.delete(k));
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
};

export const clearAllBlobs = (): Promise<void> =>
  run('readwrite', (store) => store.clear() as IDBRequest<undefined>).then(() => undefined);
